import React from 'react'
import HeroBanner from "../component/Common Banner Component/HeroBanner";
import Footer from "../component/Footer/Footer";
import OurValues from "../component/OurValues/OurValues";
import TextContent from "../component/TextContent/TextContent";
import IndustriesWeServer from "../component/IndustriesWeServer/IndustriesWeServer";
import ProjectManagmentForm from "../component/ProjectManagmentForm/ProjectManagmentForm";
import OccupiedStagging from "../component/OccupiedStagging/OccupiedStagging";
import { Helmet } from "react-helmet";
import CallToAction from '../component/CallToAction/CallToAction';
import LHSRowContent from '../component/LHSRowContent/LHSRowContent';
import LHSGridContent from '../component/LHSGridContent/LHSGridContent';
import Sponsor from '../component/Sponsor/Sponsor';

function LearnHomeStaging() {
    const text1Content = [
  "<p class='body-paragraph color-light'><b>Local Presence in Ontario –</b> Customers can call and meet one of our <b>Ontario sales representatives,</b> allowing you to close deals without opening an office or hiring staff.</p>",
  "<p class='body-paragraph color-light'><b>Industry Credibility –</b> Our team has extensive experience in <b>interior design sales in Ontario,</b> covering both commercial and residential projects, as well as the home staging business.</p>",
  "<p class='body-paragraph color-light'><b>Sales and Marketing Expertise –</b> With over 20 years in B2B and B2C retail and wholesale sales and 15+ years in interior design, we know how to grow your sales efficiently.</p>",
  "<p class='body-paragraph color-light'><b>Network Access –</b> Gain entry to our trusted network of design studios, contractors, showrooms, real estate, and hospitality clients across Ontario.</p>",
  "<p class='body-paragraph color-light'><b>Marketing Opportunity –</b> Expand your business in Ontario immediately and start generating revenue without overhead costs.</p>"
];
;

const text2Content = [
   `
<h5 class='color-dark'>RESA’s Mission & Vision</h5>
<ul class='body-list'>
  <li>
    <p class='body-paragraph color-dark'>
      <b>Mission:</b> Advancing professionalism and excellence in real estate staging by creating industry standards in order to maximize profit potential for consumers and industry professionals.
    </p>
  </li>
  <li>
    <p class='body-paragraph color-dark'>
      <b>Vision:</b> Our vision is an industry where high standards are well-established and practiced universally, and the use of professional staging is standard practice when selling real estate.
    </p>
  </li>
</ul>
`,
`
<h4 class='color-dark'>Code of Ethics</h3>
<ul class='body-list'>
  <li>
    <p class='body-paragraph color-dark'>
      <b>For consumers:</b> Honest marketing, transparent communications, and respect for privacy and safety.
    </p>
  </li>
  <li>
    <p class='body-paragraph color-dark'>
      <b>For stagers:</b> Clear standards that elevate the profession, protect reputations, and encourage fair competition.
    </p>
  </li>
</ul>
`
  ]

  return (
    <div>
        <Helmet>
          <title> 
          Learn Home Staging | MES Decors
          </title>
          <meta 
          name='description' 
          content="Learn Home Staging from a RESA Certified Instructor" 
          />
          <link rel="canonical" href="https://www.mesdecors.ca/staging-to-sell" />

        </Helmet>
      <HeroBanner
        subHeading=""
        Heading="Staging to Sell: "
        nextLineSpanHeading="What Every Agent Should Know®"
        Paragraph={`A 3-hour course that gives real estate agents the knowledge, language, and tools to use staging as a strategic marketing advantage — and earn the RESA® Certified Staging Advocate (CSA) designation.`}
        bgImg="/images/creatives/partnership-hero-bg.jpg"
        btn={false}
        btnText={""}
        btnRefTel=""
        btnLHS={true}
        sideLinks={false}
        FullWidthPara={true}
        LHStext={true}
        marginBtm={false}
        LHSLogos={true}
        heightAuto={true}
        homeIcons={true}
      />

      <LHSRowContent/>
      <LHSGridContent
        heading="Practical Knowledge Agents Can Use Right Away"
        fontDark={true}
        subHeading="What agents will learn"
        cardData={[
          {
          title:"Data, ROI & business impact",
          content:"Real numbers behind staging — faster sales, stronger offers, and how to move seller conversations from emotion to logic.",
          },
          {
          title:"Staging as a marketing & risk tool",
          content:"Why staging is a marketing strategy, not decorating — and how it connects to disclosure, ethics, and fiduciary duty.",
          },
          {
          title:"Buyer psychology & first impressions",
          content:`How buyers process homes online and in person, and why "move-in ready" perception can make or break a listing.`,
          },
          {
          title:"Execution, safety & collaboration",
          content:"How to vet and work with professional stagers, avoid the pitfalls of DIY staging, and protect your clients and listings.",
          },
        ]}
      />

       <OccupiedStagging
       textCenter={true}
        subHeading="What agents are saying"
        heading="Real results from real professionals"
        content={``}
        card1={{
            title:"",
            content:`
 <p class='body-paragraph color-light'>
    "Since your class, our first staging sold for 10% higher than anything that neighborhood had ever seen."
  </p>

  <p class="color-light fw-bold">
    — Marc Chernau, Wilcher Properties Group
  </p>

`
        }}
        card2={{
            title:"",
           content:`
 <p class='body-paragraph color-light'>
    "The class opened my eyes. I never thought I'd be convinced that staging works, but now it makes complete sense. It's a game-changer for how I present listings."
  </p>

  <p class="color-light fw-bold">
    — Catherine Zerba, Keller Williams
  </p>

`
        }}
        card3={{
            title:"",
           content:`
 <p class='body-paragraph color-light'>
   "This is a popular class that receives great reviews every time we host it. The instructors are knowledgeable, professional, and a pleasure to work with."
  </p>

  <p class="color-light fw-bold">
   — Roxie Glenn, Director of Professional Development, MetroTex Association of REALTORS®
  </p>

`
        }}
      
      contentHtml={true}
      contentHeight={true}
      hideBtn={true}
    />

 <TextContent
        subHeading="Your instructor"
        heading="Taught by a RESA® Approved Instructor"
        nextLineHeading='Louay Nouneh'
        content={`
RESA® Approved Instructor · Co-Founder, MES Décors Inc.
\n
Louay is a staging professional and business strategist with over 15 years of experience in sales leadership. He earned the RESA® Approved Instructor designation in 2026 and serves clients throughout the Halton Region and Greater Toronto Area.
\n

Completed RESA's Train-the-Trainer program and teaching exam
Holds the RESA-PRO® designation with advanced ethics standards
MBA in Business Administration`}
        btn={false}
        btnText=""
        btnRef="/"
        btnRefTel={false}
        customList={false}
        custonListBullets={false}
        shiftRow={false}
        img="/images/creatives/lhs-text-1-new.png"
        reviewContent={false}
        btnImg={false}
        fontDark={true}
      />
 

       
      <LHSGridContent
        heading="A turnkey program with real professional value"
        fontDark={false}
        subHeading="Why bring this to your brokerage or association"
        cardData={[
          {
          title:"Turnkey program",
          content:"RESA® provides instructor, course materials, and support. Nothing to prepare.",
          },
          {
          title:"Flexible scheduling",
          content:"Available in-person or virtually to fit your team's calendar.",
          },
          {
          title:"Agents earn a designation",
          content:`Every participant who completes the course earns the RESA-CSA™ designation.`,
          },
          {
          title:"Trusted nationally",
          content:"Hosted by RE/MAX, Keller Williams, Coldwell Banker, Century 21, and dozens of REALTOR® associations since 2010.",
          },
        ]}
      />
    
      <CallToAction />

      <Footer newsletterSection={true} />
    </div>
  );
}

export default LearnHomeStaging